import { createReducer } from '@reduxjs/toolkit'
import { miningPairT } from '../../constants/bakery/lists.d'
import {
  updateMiningPairMap
} from './actions'

export interface bakeryState {
  miningPair: {[symbol: string]: miningPairT}
}

const initialState: bakeryState = {
  miningPair: {}
}

export default createReducer(initialState, builder => {
  builder
    .addCase(updateMiningPairMap, (state, action) => {
      state.miningPair = {}
      const { list } = action.payload
      list.forEach((d) => {
        state.miningPair[d.baseAsset + '-' + d.quoteAsset] = d
      })
    })
})
